module.exports = __webpack_public_path__ + "static/img/chanliang.3ea5a1c9.png";